<template>
	<div class="flex gap-2 pointer-events-none">
		<div class="flex gap-x-2 pointer-events-auto">
			<Transition @enter="openTags" @leave="closeTags">
				<ul v-if="isTagsOpen" class="absolute bottom-full flex flex-col items-start justify-end gap-1 mb-1">
					<li v-for="(tag, index) in tags.slice(1, 7)" :key="index" class="inline-flex">
						<AbsoluteInternalLink
							:to="tagRouteGenerator(tag)"
							class="rounded-full text-body-inverse typo-body-caption px-3 py-2 z-10 bg-background-darker/60 hover:bg-background-darker/70 backdrop-blur-xs"
						>
							{{ tag.name }}
						</AbsoluteInternalLink>
					</li>
				</ul>
			</Transition>
			<AbsoluteInternalLink
				v-if="tags[0]"
				:to="tagRouteGenerator(tags[0])"
				class="rounded-full text-body-inverse typo-body-caption px-3 py-2 z-10 min-w-0 shrink whitespace-nowrap overflow-hidden text-ellipsis bg-background-darker/60 hover:bg-background-darker/70 backdrop-blur-xs"
				:title="tags[0].name"
			>
				{{ tags[0].name }}
			</AbsoluteInternalLink>
			<button
				v-if="isTagsButtonVisible"
				type="button"
				class="rounded-full text-body-inverse typo-body-caption p-2 relative z-10 bg-background-darker/60 hover:bg-background-darker/70 backdrop-blur-xs"
				:aria-label="isTagsOpen ? 'Zobrazit méně' : 'Zobrazit více'"
				@click="() => toggleTagsOpen()"
			>
				<NuxtIcon name="more-vertical" filled class="text-base" />
			</button>
		</div>
		<AuthorBadge
			v-if="author && typeof author === 'object'"
			:blok="author"
			class="max-sm:hidden shrink-0 ml-auto pointer-events-auto"
		/>
	</div>
</template>

<script setup lang="ts">
	import {gsap} from 'gsap';
	import type {RouteLocationRaw} from 'vue-router';
	import type {ISbDatasourceEntry} from '~/types/storyblok';
	import type {AuthorBadgeStoryBlok} from '~/types/authorBadge';

	type Props = {
		tags: ISbDatasourceEntry[];
		tagRouteGenerator: (tag: ISbDatasourceEntry) => RouteLocationRaw;
		author?: AuthorBadgeStoryBlok | string;
	};

	const props = defineProps<Props>();

	const isTagsOpen = ref(false);
	const toggleTagsOpen = useToggle(isTagsOpen);

	const isTagsButtonVisible = computed(() => props.tags.length > 1);

	function openTags(el: Element, onComplete: () => void) {
		gsap.fromTo(
			Array.from(el.children).reverse(),
			{opacity: 0, yPercent: 20},
			{opacity: 1, yPercent: 0, stagger: 0.05, duration: 0.2, onComplete},
		);
	}

	function closeTags(el: Element, onComplete: () => void) {
		gsap.to(el.children, {opacity: 0, yPercent: 20, stagger: 0.05, duration: 0.2, onComplete});
	}
</script>
